<template lang="pug">
  section.container
    .header(:class="{simple}")
      .title-block(:class="type")
        lei-popover(
        :text="tooltip")
          h1.title.w-6 {{title}}
        p.w-4.info(v-if="info") {{info}}
      slot
    slot(name="notice")
</template>
<script>
import LeiPopover from '../lei-components/LeiPopover'
import record from '../../constants/tooltips/record'
export default {
  components: {
    LeiPopover,
  },
  props: {
    title: {
      type: String,
      default: 'LEI Search',
    },
    simple: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: null,
    },
    tooltip: {
      type: Object,
      default: () => ({
        small: '',
        full: '',
      }),
    },
  },
  data () {
    return {
      tooltips: record,
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .container
    display flex
    flex-direction column
    padding 0
  .header
    display flex
    justify-content space-between
    .title-block
      margin-right 5%
      .title
        color $default-color
        font-size 2.2rem
        margin 0.5rem 0 2rem
      .info
        color $default-color
        line-height 1.5rem
      &.error
        .title
          color $danger-color

  @media (max-width: $laptop)
    .header
      flex-direction column
      order 2
      padding 0
      .title-block
        padding 0 20px 30px
        margin-right 0
        font-size 90%
        border-bottom 1px solid $default-color-light-1
        .title
          font-size 1.8rem
          margin 0.5rem 0 1.2rem
      &.simple
        flex-direction row
        order inherit
        .title-block
          margin-right 5%
          border-bottom none
  @media (max-width: $mobile)
    .header
      flex-direction column !important
      .title-block
        padding 0 20px


</style>



// WEBPACK FOOTER //
// src/components/layout-components/HeaderSection.vue